// extracted by mini-css-extract-plugin
module.exports = {"tooltipContainer":"styles_tooltipContainer__1cpdE","tooltipTextToggleSwitch":"styles_tooltipTextToggleSwitch__39_6c"};